import { connect } from 'react-redux';

import TranslationsEditingDisabledDiv from './translations_editing_disabled_div.jsx';

import {
  getTranslationsCurrentLanguageIso,
  getTranslationsDefaultLanguageIso,
} from 'zoomforth_codesbane_viewer/reducers/index.js';


const mapStateToProps = (state)=> {
  const currentLanguageIso = getTranslationsCurrentLanguageIso(state);
  const defaultLanguageIso = getTranslationsDefaultLanguageIso(state);

  const isEditingSecondaryLanguage = currentLanguageIso !== defaultLanguageIso;

  return {
    isDisabled: isEditingSecondaryLanguage
  };
};

const mapDispatchToProps = ()=> {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TranslationsEditingDisabledDiv);
